import './index.less';

//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook } = checkApp.core;//eslint-disable-line
const { Button } = checkApp.components;//eslint-disable-line

const prevUrl = '//wanwang.aliyun.com/domain/searchresult';

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('backPrev', [], 99999)
export default class BackPrevFeature extends Feature {

  @hook('breadcrumb.content')
  createButton() {
    return <Button className='pull-right back-prev'
      type="dark" shape="ghost" size="small"
      onClick={() => location.href = prevUrl}>返回旧版</Button>;
  }

}


// WEBPACK FOOTER //
// ./src/back-prev/index.js